import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { ProgramsType } from './types';

const parcePrograms = (data: ProgramsType) => ({
  status: data!.status || '',
  title: data!.title || '',
  teamTitle: data!.tutor_tutored_title || '',
  startDate:
    data.date_start && data.date_start.length
      ? `Начало работы ${format(data.date_start, 'DD.MM.YYYY')}`
      : 'Начало работы не определено',
  endDate:
    data.date_end && data.date_end.length
      ? `Завершена ${format(data.date_end, 'DD.MM.YYYY')}`
      : '',
  curator: {
    fio: data!.curator!.fio || '',
    image: data!.curator!.photo_url || '',
    gender: data!.curator!.gender || 'N',
  },
  mentor: {
    fio: data!.tutor!.fio || '',
    image: data!.tutor!.photo_url || '',
    gender: data!.tutor!.gender || 'N',
  },
  list: isArrayNotEmpty(data.meetings)
    ? data.meetings.map((items) => ({
        day: items.date && items.date.length ? format(items.date, 'D') : '',
        month:
          items.date && items.date.length
            ? format(items.date, 'MMMM', { locale: ruLocale }).slice(0, 3)
            : '',
        time:
          items.date && items.date.length ? format(items.date, 'HH:mm') : '',
        status: items!.status || '',
        id: items!.id || '',
      }))
    : [],
});

export default parcePrograms;



// WEBPACK FOOTER //
// ./src/services/mentoring/utils/parcePrograms.ts